import {
  IconCart,
  IconCartOutline,
  IconHamburger,
  IconHeart,
  IconHeartOutline,
  IconHome,
  IconHomeOutline,
  IconProps,
  IconUser,
  IconUserOutline,
} from "@catchoftheday/cg-components";

export type BottomNavItem = {
  title: string;
  url?: string;
  icon: React.FC<IconProps>;
  activeIcon: React.FC<IconProps>;
};

export const BOTTOM_NAV: BottomNavItem[] = [
  {
    title: "Home",
    url: "/",
    icon: IconHomeOutline,
    activeIcon: IconHome,
  },
  {
    title: "Wishlist",
    url: "/my-account/wishlist",
    icon: IconHeartOutline,
    activeIcon: IconHeart,
  },
  {
    title: "Categories",
    icon: IconHamburger,
    activeIcon: IconHamburger,
  },
  {
    title: "Cart",
    url: "/cart",
    icon: IconCartOutline,
    activeIcon: IconCart,
  },
  {
    title: "Account",
    icon: IconUserOutline,
    activeIcon: IconUser,
  },
];
